import { render, staticRenderFns } from "./CompanyApproval.vue?vue&type=template&id=b8063822&scoped=true&"
import script from "./CompanyApproval.vue?vue&type=script&lang=js&"
export * from "./CompanyApproval.vue?vue&type=script&lang=js&"
import style0 from "./CompanyApproval.vue?vue&type=style&index=0&id=b8063822&prod&scoped=true&lang=css&"
import style1 from "./CompanyApproval.vue?vue&type=style&index=1&id=b8063822&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8063822",
  null
  
)

export default component.exports